import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-categoria-edit',
  templateUrl: './categoria-edit.component.html',
  styleUrls: ['./categoria-edit.component.css']
})
export class CategoriaEditComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=3200;
  resultado:any=[];
  activo:boolean;
  esNuevo:boolean;
  grupo:any=[];
  thisForm = new FormGroup({
    categoria: new FormControl(this.data.item.categoria, [Validators.required, Validators.minLength(3)]),
    gpo: new FormControl(this.data.item.idGpo, [Validators.required, Validators.minLength(4)]),
    etiq: new FormControl(this.data.item.etiqueta, [Validators.required, Validators.minLength(4)]),
    etiq2: new FormControl(this.data.item.etiqueta2, []),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<CategoriaEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    //console.log(this.data);
    this.loading = true;
    if(this.data){
      if(this.data.id > 0)
        this.esNuevo=false;
      else
        this.esNuevo=true;
      this.activo = this.data.item.act
    }
    this.dataService.getGrupos().subscribe(
                      rows => {   
                              this.grupo = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnGrupoCargado());
  }

  fnGrupoCargado(){
    this.loading = false;
  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="GPO" && idEl != undefined){
      this.data.item.tipo = idEl;
      this.thisForm.controls["gpo"].setValue(idEl);
    }
  }

  fnDesactivar(){
    this.activo = false;
  }

  fnActivar(){
    this.activo = true;
  }

  fnGuardar(){
    this.loading = true;
    if(this.esNuevo){
      //console.log("GUARDAR");
      //--> Categoría con nombre y mínimo 3 caracteres, selección de grupo y asignación de línea 1:
      if(this.thisForm.valid)
        this.dataService.insCategoria(this.thisForm.controls["categoria"].value, this.activo, this.thisForm.controls["gpo"].value, this.dataService.findItemInObject(this.grupo, this.thisForm.controls["gpo"].value, "idGrupo").grupo, null, this.thisForm.controls["etiq"].value, this.thisForm.controls["etiq2"].value).subscribe(
                                  rows => {   
                                          this.resultado = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnCategoriaGuardada());    
    
      else{
        //console.log(this.thisForm.controls["categoria"].errors);
        if(this.thisForm.controls["categoria"].errors){
          if(this.thisForm.controls["categoria"].errors.required){
            this.fnMuestraMensaje("ERR", "Capture una 'categoria' de producto'.", true, false);
            return;
          }
          if(this.thisForm.controls["categoria"].errors.minlength){
            //console.log(this.thisForm.controls["categoria"].errors.minlength.actualLength);
            if(this.thisForm.controls["categoria"].errors.minlength.actualLength < this.thisForm.controls["categoria"].errors.minlength.requiredLength)
              this.fnMuestraMensaje("ERR", "La 'categoria' de producto debe contener " + this.thisForm.controls["categoria"].errors.minlength.requiredLength + " o más caracteres.", true, false)
            return;
          }
        }
        if(this.thisForm.controls["gpo"].errors){
          if(this.thisForm.controls["gpo"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture un 'grupo' (área).", true, false);
          return;
        }
        if(this.thisForm.controls["etiq"].errors){
          if(this.thisForm.controls["etiq"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture 'línea 1' (texto a mostrar en reporte).", true, false);
          return;
        }
      }
    }
    else{
      //console.log("EDITAR");
      //--> Selección de grupo y asignación de línea 1:
      if(this.thisForm.valid)
        this.dataService.updCategoria(this.data.id, this.activo, this.thisForm.controls["gpo"].value, this.dataService.findItemInObject(this.grupo, this.thisForm.controls["gpo"].value, "idGrupo").grupo, null, this.thisForm.controls["etiq"].value, this.thisForm.controls["etiq2"].value).subscribe(
                                  rows => {   
                                          this.resultado = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnCategoriaEditada());    
     
      else{
        if(this.thisForm.controls["gpo"].errors){
          if(this.thisForm.controls["gpo"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture un 'grupo' (área).", true, false);
          return;
        }
        if(this.thisForm.controls["etiq"].errors){
          if(this.thisForm.controls["etiq"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture 'línea 1' (texto a mostrar en reporte).", true, false);
          return;
        }
      }
    }
  }
  
  fnCategoriaGuardada(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      this.fnMuestraMensaje("OK", "Registro almacenado", false, true);
    }
    else{
      this.fnMuestraMensaje("ERR", "Error al almacenar registro", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);
    }
  }  

  fnCategoriaEditada(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      this.okMsg = "Registro actualizado"
      setTimeout(() => {
        this.okMsg = "";
        this.loading = false;
        this.dialogRef.close();
      }, this.tiempoMsg);
    }
    else{
      this.errMsg = "Error al actualizar registro!"
      setTimeout(() => {
        this.errMsg = "";
        this.loading = false;
        console.log("LOADING:" + this.loading);
      }, this.tiempoMsg);
    }
  }

}
